import styled from '@emotion/styled';
import { CSSProperties, InputHTMLAttributes } from 'react';

import { IconChecked, IconUnchecked } from '../../common/design-tokens/Icons';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  iconStyle?: CSSProperties;
}

const CheckboxInput = styled.input`
  &:focus + span > svg {
    border-radius: 4px;
    box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.blueLight30};
  }
`;

export default function Checkbox({ iconStyle, ...props }: Props) {
  return (
    <>
      <CheckboxInput type="checkbox" className="sr-only" {...props} />
      <span style={iconStyle} aria-hidden>
        {props.checked ? <IconChecked /> : <IconUnchecked />}
      </span>
    </>
  );
}
